import React from "react";
//import PageLoaderImg from "../../../assets/images/loader.gif";

const Loader = () => {
  return (
    <div id="preloader">
      <div id="status">
        <div className="spinner-chase">
          <div className="chase-dot"></div>
          <div className="chase-dot"></div>
          <div className="chase-dot"></div>
          <div className="chase-dot"></div>
        </div>
      </div>
    </div>
  );
};

export const PageLoader = () => {
  return (
    /*<div id="page-loading">
        <img id="page-loading-image" src={PageLoaderImg} alt="Loading..." />
    </div>*/
    <div id="page-loading">
        <div id="page-loading-image">
        <img src="" alt="" />
          <h5 className="mt-3">Loading...</h5>
        </div>
    </div>
  );
};
export default Loader;
